import React from 'react';
import PersonCard from '../components/PersonCard';
import peopleData from '../people.json';
import './People.css';

function People() {
  const { team } = peopleData;

  return (
    <div className="page people-page">
      <div className="container">
        <header className="page-header">
          <h1>Our People</h1>
          <div className="accent-bar"></div>
        </header>

        {team.map((section) => (
          <section key={section.section} className="people-section">
            <h2 className="section-title">{section.section}</h2>
            <div className="people-list">
              {section.members.map((person) => (
                <PersonCard
                  key={person.name}
                  name={person.name}
                  role={person.role}
                  image={person.image}
                  bio={person.bio}
                />
              ))}
            </div>
          </section>
        ))}
      </div>
    </div>
  );
}

export default People;
